<template>
    <Card :title="$t('arrivalDeclaration.arrivalDeclarationTable')">
        <div class="card-body">
            <button class="btn btn-link" @click="$refs.modal.show()">
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </button>
        </div>
        <DataTable
            ref="DataTable"
            :config="table.config"
        >
            <template #cell-id="{item}">
                <Paragraph>
                    <template #title>
                        <router-link :to="{ name: 'EditArrivalDeclarationPage', params: { arrivalDeclarationUuid: item.uuid } }">{{ item.id }}</router-link>
                    </template>
                    <template #description>
                        <span v-if="item.creatable?.name !== null">
                            <span>{{ $t('arrivalDeclaration.createFromAlert') }}: </span>
                            <router-link v-if="item.creatable?.name === 'exit-declaration' && item.creatable.uuid" :to="{ name: 'EditExitDeclarationPage', params: { exitDeclarationUuid: item.creatable.uuid }}" class="text-primary font-weight-semibold cursor-pointer">{{ `${$t('labels.exit_declaration')} № ${item.creatable?.id}` }}</router-link>
                            <span v-else-if="item.creatable?.name === 'exit-declaration'">{{ `${$t('labels.exit_declaration')} № ${item.creatable?.id}` }}</span>
                            <router-link v-else-if="item.creatable?.name === 'inventory' && item.creatable.uuid" :to="{ name: 'EditInventoryPage', params: { inventoryUuid: item.creatable.uuid }}" class="text-teal font-weight-semibold cursor-pointer">{{ `${$t('labels.inventory')} № ${item.creatable?.id}` }}</router-link>
                            <span v-else-if="item.creatable?.name === 'inventory'">{{ `${$t('labels.inventory')} № ${item.creatable?.id}` }}</span>
                        </span>
                        <span v-else>{{ $t('arrivalDeclaration.createdManualAlert') }}</span>
                    </template>
                </Paragraph>
            </template>
            <template #cell-status="{item}">
                <span class="badge" :style="{
                    background: item.status.id,
                    color : 'white'
                }">{{ item.status.name }}</span>
            </template>
            <template #cell-product_items_sum="{item}">
                <span>
                    <Paragraph>
                        <template #title>
                            <Tooltip trigger="mouseenter focus">
                                <Tooltip trigger="click" @onShow="fetchProducts(item.uuid)" @onHide="productsString = ''">
                                    <template #default>
                                        <span class="text-indigo cursor-pointer"><u>{{ Price.factory(item.product_items_sum).toCurrencyString(item.currency_code) }}</u></span>
                                    </template>
                                    <template #content>
                                        <div class="tippy-body" style="overflow: hidden;">
                                            <span style="white-space: nowrap; ">
                                                <ol class="list mb-0" v-html="productsString"></ol>
                                            </span>
                                        </div>
                                    </template>
                                </Tooltip>
                                <template #content>
                                    <div class="tippy-body">
                                        {{ $t('alerts.click_to_show_product_name') }}
                                    </div>
                                </template>
                            </Tooltip>
                        </template>
                    </Paragraph>
                </span>
            </template>
            <template #cell-created_at="{item}">
                <span>{{ DateFormatter.formatDateTime(item.created_at) }}</span>
            </template>
        </DataTable>
    </Card>

    <CreateArrivalDeclarationModal ref="modal" @created="$refs.DataTable.load()"/>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import DataTable from '../../../../components/new/datatable/DatatableComponent.vue'
import pageData from './data.json'
import Paragraph from "../../../../components/table/ParagraphComponent.vue";
import Tooltip from '../../../../components/TooltipComponent.vue';
import Button from '../../../../components/new/button/AlphaButton.vue';
import Price from '../../../../services/Price/Price.ts';
import CreateArrivalDeclarationModal from './modals/CreateArrivalDeclarationModal.vue';
import { httpClient } from '../../../../services/HttpClient';
import DateFormatter from "../../../../services/DateFormatter"

export default {
    name: "IndexArrivalDeclarationPage",
    components: {
        Card, DataTable, Paragraph, Tooltip, Button, CreateArrivalDeclarationModal
    },
    data() {
        return {
            DateFormatter,
            Price: Price,
            table: {
                config: pageData.table,
            },
            productsString: ""
        }
    },
    methods: {
        async fetchProducts(item) {
            await httpClient.get(`/management/arrival-declarations/products`, {
                arrival_declaration_uuids: [item]
            }).then(response => {
                this.productsString = response.data.data.map(item => `<li>${item.product.name}</li>`).join('')
            })
        }
    },
    watch: {
        '$route.query.template'(newTemplate) {
            this.table.config.templateUuid = newTemplate ?? null;
            this.$refs.DataTable.reload();
        }
    },
    mounted() {
        this.$refs.DataTable.load();
    },
    beforeMount() {
        this.table.config.templateUuid = this.$route.query.template;
    },
    beforeUnmount() {
        this.table.config.filters.forEach((filter) => {
            filter.default = 0;
        });
        this.table.config.templateUuid = null;
    }
}
</script>

<style scoped>
    ol {
        padding-inline-start: 20px
    }
</style>
